import { z } from "zod";

import { DatabaseDefaults } from "@/src/models/database-defaults";

export enum CloudCruiseRunType {
  CARELINK = "carelink",
  ECW_DOCUMENT_METADATA_SETUP = "ecw_document_metadata_setup",
  ECW_DOCUMENT_UPLOAD = "ecw_document_upload",
  ECW_METADATA_UPDATE = "ecw_metadata_update",
  ECW_ORDER_ATTACHMENT = "ecw_order_attachment",
  ECW_ORDER_UPDATE = "ecw_order_update",
  ECW_PATIENT_SEARCH = "ecw_patient_search",
  ECW_REFERRAL_ATTACHMENT = "ecw_referral_attachment",
  ECW_REFERRAL_CLOSURE = "ecw_referral_closure",
  ECW_REFERRAL_ORDER_CREATION = "ecw_referral_order_creation",
  ECW_PATIENT_METADATA_UPDATE = "ecw_patient_metadata_update",
  ECW_TELEPHONE_ENCOUNTER_CREATION = "ecw_telephone_encounter_creation",
  ECW_TE_ATTACHMENT = "ecw_te_attachment",
  NOTIFYMD_EXTRACT = "notifymd_extract",
  FCC_CHART_UPSERT = "fcc_chart_upsert",
  FCC_DOC_UPLOAD = "fcc_doc_upload",
  FCC_CLINICAL_FORM = "fcc_clinical_form",
  FCC_REFERRAL_TRACKING_UPDATE = "fcc_referral_tracking_update",
  BALANCE_MODMED_RECALL_CREATE = "balance_modmed_recall_create",
  BALANCE_MODMED_ATTACH_DOC_TO_TASK = "balance_modmed_attach_doc_to_task",
  BALANCE_MODMED_GENERAL_TASK_CREATE = "balance_modmed_general_task_create",
  BALANCE_MODMED_DOC_ASSOCIATED_TASK = "balance_modmed_doc_associated_task",
  BALANCE_MODMED_COMMS_ESCALATION_TASK_CREATE = "balance_modmed_comms_escalation_task_create",
  BALANCE_MODMED_WORKERS_COMP_TASK_CREATE = "balance_modmed_workers_comp_task_create",
  MODMED_PATIENT_TASK_CREATE = "modmed_patient_task_create",
  /** @deprecated use MODMED_PATIENT_TASK_CREATE; kept so historical cloudcruise_runs rows parse. */
  BALANCE_MODMED_PATIENT_TASK_CREATE = "balance_modmed_patient_task_create",
  /** @deprecated use MODMED_PATIENT_TASK_CREATE; kept so historical cloudcruise_runs rows parse. */
  APEX_MODMED_PATIENT_TASK_CREATE = "apex_modmed_patient_task_create",
  APEX_MODMED_ATTACH_DOC_TO_TASK = "apex_modmed_attach_doc_to_task",
  MODMED_ATTACH_DOC_TO_TASK = "modmed_attach_doc_to_task",
  MODMED_PERFORMED_DATE_UPDATE = "modmed_performed_date_update",
  MODMED_CLICK_CHECK_ELIGIBILITY = "modmed_click_check_eligibility",
}

export enum CloudCruiseRunStatus {
  PROCESSING = "processing",
  SUCCEEDED = "succeeded",
  FAILED = "failed",
}

export const cloudCruiseRunSchema = z.object({
  runId: z.string(),
  groupId: z.string().uuid(),
  taskId: z.string().uuid().nullable(),
  type: z.nativeEnum(CloudCruiseRunType),
  workflowId: z.string().nullable(),
  stepKey: z.string().nullable(),
  status: z.nativeEnum(CloudCruiseRunStatus),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type CloudCruiseRun = z.infer<typeof cloudCruiseRunSchema> & DatabaseDefaults;

export const cloudCruiseRunShape: CloudCruiseRun = {
  id: "",
  runId: "",
  groupId: "",
  taskId: null,
  type: CloudCruiseRunType.CARELINK,
  workflowId: null,
  stepKey: null,
  status: CloudCruiseRunStatus.PROCESSING,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
};
